import { Box, styled } from '@mui/material';
import { Typography } from '@chargeafter/ui';
import { ModalHeaderWithExitButton } from './ModalHeaderWithExitButton';
import { AppView, EInternalSettleModal } from '../constants';
import { SettleOptions } from '../services/configManager';
import { useConfirm } from '../services/confirmationModalManager';

const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: theme.spacing(78),
}));

const useSettlementConfigurationModal = () => {
  const settlementConfig = useConfirm(AppView.SettlementConfiguration);
  return async (): Promise<Omit<SettleOptions, 'AutomaticAndManual'>> => {
    try {
      await settlementConfig({
        allowClose: true,
        title: <ModalHeaderWithExitButton title={EInternalSettleModal.Title} />,
        confirmationText: EInternalSettleModal.ConfirmButtonText,
        cancellationText: EInternalSettleModal.CancelButtonText,
        description: (
          <StyledContainer data-testId="settle-selection-modal-description">
            <Typography variant="body1" color="grey.800">
              {EInternalSettleModal.Description}
            </Typography>
          </StyledContainer>
        ),
      });
      return 'Automatic';
    } catch (e) {
      return 'Manual';
    }
  };
};

export default useSettlementConfigurationModal;
